"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateTimePicker = void 0;
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const react_1 = __importStar(require("react"));
const makePicker_1 = __importDefault(require("../helpers/makePicker"));
const DatePicker_1 = __importDefault(require("./DatePicker"));
const TimePicker_1 = __importDefault(require("./TimePicker"));
exports.DateTimePicker = (0, makePicker_1.default)((props) => {
    const { value, onChange } = props, otherProps = __rest(props, ["value", "onChange"]);
    const handleChangeDatePart = (0, react_1.useCallback)(v => {
        const oldDate = (0, moment_timezone_1.default)(value);
        const newDate = (0, moment_timezone_1.default)(v)
            .hours(oldDate.hours())
            .minutes(oldDate.minutes())
            .seconds(oldDate.seconds())
            .milliseconds(oldDate.milliseconds());
        if (newDate.isValid())
            onChange === null || onChange === void 0 ? void 0 : onChange(newDate);
    }, [onChange, value]);
    const handleChangeTimePart = (0, react_1.useCallback)(v => {
        const oldDate = (0, moment_timezone_1.default)(value);
        const newDate = (0, moment_timezone_1.default)(v)
            .date(oldDate.date())
            .month(oldDate.month())
            .year(oldDate.year());
        if (newDate.isValid())
            onChange === null || onChange === void 0 ? void 0 : onChange(newDate);
        onChange === null || onChange === void 0 ? void 0 : onChange(newDate);
    }, [onChange, value]);
    return (react_1.default.createElement(Horizontal_1.default, { shrink: true, style: { marginBottom: 8, minWidth: 340 }, gutter: true, centered: true },
        react_1.default.createElement(DatePicker_1.default, Object.assign({ value: value, onChange: handleChangeDatePart }, otherProps)),
        react_1.default.createElement(TimePicker_1.default, Object.assign({ value: value, onChange: handleChangeTimePart }, otherProps))));
});
exports.default = exports.DateTimePicker;
